import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";

const BarChartBase = ({
  data,
  xKey,
  yKey,           
  yKeys,             
  height = 220,
  barColor = "#10b981", 
  gradientIds,       
  gradientColors = [["#a855f7", "#6366f1"]], 
  useGradient = false,
  radius = [8, 8, 0, 0],
  textSize=12,
}) => {
  const isMultiBar = Array.isArray(yKeys) && yKeys.length > 0;

  const getGradientColors = (idx) => gradientColors[idx] || gradientColors[0];

  return (
    <div style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          barCategoryGap="10%"
          barGap={4}
          margin={{ top: 5, right: 12, left: 12, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={true} />

          <XAxis
            dataKey={xKey}
            tick={{ fill: "#64748b", fontSize: textSize }}
            axisLine={{ stroke: "#64748b" }}
            tickLine={{ stroke: "#64748b" }}
          />

          <YAxis
            tick={{ fill: "#64748b", fontSize: textSize }}
            axisLine={{ stroke: "#64748b" }}
            tickLine={{ stroke: "#64748b" }}
          />

          <Tooltip
            cursor={{ fill: "#f1f5f9" }}
            contentStyle={{
              borderRadius: 8,
              border: "1px solid #e2e8f0",
              fontSize: textSize,
            }}
          />

          {useGradient && (
            <defs>
              {isMultiBar
                ? yKeys.map((_, idx) => {
                    const colors = getGradientColors(idx);
                    return (
                      <linearGradient
                        key={idx}
                        id={gradientIds?.[idx] || `gradient-${idx}`}
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="1"
                      >
                        <stop offset="0%" stopColor={colors[0]} />
                        <stop offset="100%" stopColor={colors[1]} />
                      </linearGradient>
                    );
                  })
                : (() => {
                    const colors = getGradientColors(0);
                    return (
                      <linearGradient
                        id={gradientIds?.[0] || "barGradient"}
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="1"
                      >
                        <stop offset="0%" stopColor={colors[0]} />
                        <stop offset="100%" stopColor={colors[1]} />
                      </linearGradient>
                    );
                  })()}
            </defs>
          )}

          {isMultiBar
            ? yKeys.map((key, idx) => (
                <Bar
                    dataKey={yKey}
                    fill={"#10b981"}
                    radius={[8, 8, 0, 0]}
                />
              ))
            : (
                <Bar
                  dataKey={yKey}
                  fill={useGradient ? `url(#${gradientIds?.[0] || "barGradient"})` : barColor}
                  radius={radius}
                />
              )}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarChartBase;
